import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { API_URL } from '../config';

function LoginPage() {
  const { login } = useAuth();

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        console.log("Google token response:", tokenResponse);
        const res = await axios.post(`${API_URL}/api/auth/google-login`, {
          token: tokenResponse.access_token,
        });
        if (res.data.success) {
          login(res.data.token, res.data.user);
        } else {
          console.error("Backend login failed:", res.data.error);
          alert(`Login failed: ${res.data.error}`);
        }
      } catch (error) {
        console.error("Google login error:", error);
        const errorMsg = error.response?.data?.error || error.message || "Unknown error";
        alert(`Login failed: ${errorMsg}`);
      }
    },
    onError: (errorResponse) => {
      console.error("Google login failed:", errorResponse);
      alert("Google authentication failed. Please try again.");
    },
    flow: 'implicit',
  });

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Container>
        <Card style={{ maxWidth: '500px', margin: '0 auto' }} className="shadow-lg">
          <Card.Body className="p-5 text-center">
            <div className="mb-4">
              <div className="display-4 mb-3" aria-hidden="true">🎨</div>
              <h1 className="h2 mb-2">Accessible Design Tool</h1>
              <p className="text-muted">
                Create accessible workflows with AI-powered agents
              </p>
            </div>
            
            <hr className="my-4" />
            
            <div className="mb-4">
              <p className="text-muted mb-3">
                Sign in with your Google account to access the application
              </p>
              <Button 
                variant="primary" 
                size="lg" 
                onClick={() => googleLogin()}
                className="w-100"
                style={{
                  background: '#4285f4',
                  border: 'none',
                  padding: '12px',
                  fontSize: '16px',
                  fontWeight: '500'
                }}
              >
                <i className="fab fa-google me-2"></i>
                Sign in with Google
              </Button>
            </div>
            
            <small className="text-muted">
              By signing in, you agree to use this tool responsibly
            </small>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default LoginPage;

